/**
 * Pushes a new state to the browsers history stack with optional search params
 * @param path the path to go to
 * @param searchParams optional searchParams
 * @param state optional state to store on history stack
 * @param replaceState optional true for replaceState rather than pushState
 */
export const pushState = (path: string, searchParams?: Record<string, string>, state = {}, replaceState = false): void => {
  let paramsString = '';
  if (searchParams && Object.keys(searchParams).length > 0) {
    const urlSearchParams = new URLSearchParams(searchParams);
    paramsString = '?' + urlSearchParams.toString();
  }
  if (!replaceState) {
    window.history.pushState(state, null, path + paramsString);
  } else {
    window.history.replaceState(state, null, path + paramsString);
  }
};
